export const keys = (o) => Object.keys(o);
export const entries = (o) => Object.entries(o);
export function pick(keys, obj) {
    return keys.reduce((picked, name) => {
        picked[name] = obj[name];
        return picked;
    }, {});
}
//# sourceMappingURL=object.js.map